import React, {FC} from "react";
import {Link} from "react-router-dom";
import {CalendarDaysIcon, MapPinIcon} from "@heroicons/react/24/outline";
import {EventType} from "data/types";
import Badge from "shared/Badge/Badge";
import NcImage from "shared/NcImage/NcImage";
import {convertServerDateToLocalDateShort} from "utils/convertServerDateToLocalDate";

/** An event of an organizer's list, which carries no prices nor location. */
const OrganizerEventCard: FC<{event: EventType}> = ({event}) => {
  const {customDate, customTime} = convertServerDateToLocalDateShort(
    event.startTime,
  );
  const encodedId = btoa(JSON.stringify({event: event._id}));

  return (
    <Link
      to={`/detailEvent/${encodedId}`}
      className="group flex h-full flex-col overflow-hidden rounded-3xl border border-neutral-100 dark:border-neutral-800 bg-white dark:bg-neutral-900 transition-shadow hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
    >
      <div className="relative overflow-hidden">
        <NcImage
          containerClassName="aspect-w-1 aspect-h-1 w-full"
          className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
          src={event.img}
          alt={event.nameEvent}
        />
        <div className="absolute left-3 top-3">
          <Badge name={event.category} color="yellow" />
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-4">
        <h3 className="text-base font-semibold capitalize line-clamp-2">
          {event.nameEvent}
        </h3>
        <div className="mt-auto space-y-1.5 text-sm text-neutral-500 dark:text-neutral-400">
          <p className="flex items-center gap-2">
            <CalendarDaysIcon className="w-4 h-4 shrink-0" />
            <span>
              {customDate} · {customTime}
            </span>
          </p>
          {event.category !== "Sorteo" && (
            <p className="flex items-center gap-2">
              <MapPinIcon className="w-4 h-4 shrink-0" />
              <span className="truncate">
                {[event.place, event.city?.description]
                  .filter(Boolean)
                  .join(", ")}
              </span>
            </p>
          )}
        </div>
      </div>
    </Link>
  );
};

export default OrganizerEventCard;
